import { useRequestStatusSelectOptions } from "components/UI/Selects/RequestStatusSelectSearchable/useRequestStatusSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const RequestStatusSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useRequestStatusSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.status"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
